import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <div className="px-6 py-4 border-b border-slate-200 flex flex-wrap items-center justify-between gap-4 bg-white">
      <div>
        {eyebrow && (
          <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#C8A24B] mb-0.5">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl font-semibold tracking-tight text-[#0F172A]" data-testid={testid}>
          {title}
        </h1>
        {subtitle && <p className="text-xs text-slate-500 mt-1 max-w-xl leading-relaxed">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 items-center">{actions}</div>}
    </div>
  );
}
